// placeholder parameters sumbitted with the GP Service that returns a report for the user-selected urban area

export const urbanReport = {
  nameField: "TPL_P_NAME",
  projectsLayerId: "selectedProjects",
  serviceLayerId: "serviceAreas",
  tables: {
    Area: {
      chart: null,
      pdf: {
        y: 0,
      },
      head: {
        type: "Statistic",
        class: "Served",
        fields: [
          {
            disp: "Value",
          },
        ],
      },
      body: {
        fields: [
          {
            name: "SUM_SA_AREA",
            oname: "SUM_SVCAREA",
            pname: "SUM_SVCAREA",
            disp: "Service Area",
            fill_lt: "#89BDD9",
            fill_dk: "#2D8AB5",
            stroke: "#007FAD",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
        ],
      },
    },
    Population: {
      chart: "bar",
      vertical: false,
      pdf: {
        y: 72,
      },
      head: {
        type: "Demographic",
        class: "Served",
        fields: [
          {
            disp: "Total",
          },
          {
            disp: "New",
          },
        ],
      },
      body: {
        fields: [
          {
            name: "SUM_SA_TOT_POP",
            oname: "SUM_TOTPOPSVCA",
            pname: "SUM_TOTPOPSVCA",
            disp: "Total Population",
            fill_lt: "#89BDD9",
            fill_dk: "#4797BF",
            stroke: "#007FAD",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
        ],
      },
    },
    Age: {
      chart: "bar",
      pdf: {
        y: 216,
      },
      head: {
        type: "Demographic",
        class: "People Served",
        fields: [
          {
            disp: "Total",
          },
          {
            disp: "New",
          },
        ],
      },
      body: {
        fields: [
          {
            name: "SUM_SA_KIDS",
            oname: "SUM_KIDS_SVCA",
            pname: "SUM_KIDSVCA",
            disp: "Youth (<20)",
            fill_lt: "#72B0CF",
            fill_dk: "#2D8AB5",
            stroke: "#007FAD",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_YOUNG_PROS",
            oname: "SUM_YOUNG_PRO_SVCA",
            pname: "SUM_YOUNGPROSVCA",
            disp: "Adults (20-64)",
            fill_lt: "#9DC9E0",
            fill_dk: "#5DA4C7",
            stroke: "#4797BF",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_SENIORS",
            oname: "SUM_SENIORS_SVCA",
            pname: "SUM_SENIORSVCA",
            disp: "Seniors (>64)",
            fill_lt: "#E3F4FC",
            fill_dk: "#9DC9E0",
            stroke: "#89BDD9",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
        ],
      },
    },
    Income: {
      chart: "bar",
      pdf: {
        y: 360,
      },
      head: {
        type: "Demographic",
        class: "Households Served",
        fields: [
          {
            disp: "Total",
          },
          {
            disp: "New",
          },
        ],
      },
      body: {
        fields: [
          {
            name: "SUM_SA_HHI_LOW",
            oname: "SUM_HHILOWSVCA",
            pname: "SUM_HHILOWSVCA",
            disp: "Low Income (<75% MAI)",
            fill_lt: "#72B0CF",
            fill_dk: "#2D8AB5",
            stroke: "#007FAD",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_HHI_MED",
            oname: "SUM_HHIMEDSVCA",
            pname: "SUM_HHIMEDSVCA",
            disp: "Medium Income (75%-125% MAI)",
            fill_lt: "#9DC9E0",
            fill_dk: "#5DA4C7",
            stroke: "#4797BF",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_HHI_HGH",
            oname: "SUM_HHIHGHSVCA",
            pname: "SUM_HHIHGHSVCA",
            disp: "High income (>125% MAI)",
            fill_lt: "#E3F4FC",
            fill_dk: "#9DC9E0",
            stroke: "#89BDD9",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
        ],
      },
    },
    Race: {
      chart: "bar",
      vertical: false,
      pdf: {
        y: 504,
      },
      head: {
        type: "Demographic",
        class: "People Served",
        fields: [
          {
            disp: "Total",
          },
          {
            disp: "New",
          },
        ],
      },
      body: {
        fields: [
          {
            name: "SUM_SA_WHITE",
            oname: "SUM_WHITE_SVC",
            pname: "SUM_WHITE_SVC",
            disp: "White",
            fill_lt: "#e3f5f4",
            fill_dk: "#9edbd9",
            stroke: "#74cbc8",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_BLACK",
            oname: "SUM_BLACK_SVC",
            pname: "SUM_BLACK_SVC",
            disp: "Black",
            fill_lt: "#dce2f0",
            fill_dk: "#c2cce4",
            stroke: "#a8b6d9",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_ASIAN",
            oname: "SUM_ASIAN_SVC",
            pname: "SUM_ASIAN_SVC",
            disp: "Asian",
            fill_lt: "#cce1e9",
            fill_dk: "#4d96b1",
            stroke: "#006990",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_AMERIND",
            oname: "SUM_AMERINDSVC",
            pname: "SUM_AMERINDSVC",
            disp: "Native American",
            fill_lt: "#c9daac",
            fill_dk: "#a0be6d",
            stroke: "#85ab44",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_PACIFIC",
            oname: "SUM_PACIFICSVC",
            pname: "SUM_PACIFICSVC",
            disp: "Pacific Islander",
            fill_lt: "#d699ae",
            fill_dk: "#b74d6d",
            stroke: "#572828ad3358",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_OTHRACE",
            oname: "SUM_OTHRACESVC",
            pname: "SUM_OTHRACESVC",
            disp: "Other Race",
            fill_lt: "#f4c5a5",
            fill_dk: "#eb9a61",
            stroke: "#e78540",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_RACE2UP",
            oname: "SUM_RACE2UPSVC",
            pname: "SUM_RACE2UPSVC",
            disp: "Two or More Races",
            fill_lt: "#f0e0a0",
            fill_dk: "#f3c958",
            stroke: "#f1be35",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
          {
            name: "SUM_SA_HISP",
            oname: "SUM_HISP_SVC",
            pname: "SUM_HISP_SVC",
            disp: "Hispanic",
            fill_lt: "#f0f0bb",
            fill_dk: "#e4e589",
            stroke: "#d9da56",
            value: 0,
            newvalue: "N/A",
            newpercentvalue: "N/A",
            percentvalue: "N/A",
          },
        ],
      },
    },
  },
  ReportType: "City",
  ReportArea: "Urban",
  ProjectName: "",
  IsExistingPark: false,
  CityOrUrbanID: "",
  PlaceStats: {},
  UrbanStats: {},
};
